// Module
var code = "<div class=\"fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6\"> <div class=\"toast-container w-full flex flex-col items-center space-y-4 sm:items-start\"> </div> </div> ";
// Exports
module.exports = code;